import React from "react";
import { Button } from "react-bootstrap";

const TYPE_ICONS: Record<string, string> = {
  photo: "\u{1F4F7}",
  video: "\u{1F3AC}",
  youtube: "\u{25B6}\u{FE0F}",
  pdf: "\u{1F4C4}",
  article: "\u{1F4DD}",
  text: "\u{1F4AC}",
  badge: "\u{1F3C5}",
  achievement: "\u{1F3C6}",
  milestone: "\u{1F6A9}",
  certificate: "\u{1F4DC}",
};

interface Item {
  id: number;
  itemType: string;
  title: string | null;
  description: string | null;
  eventDate: string | null;
  mediaUrl: string | null;
  youTubeUrl: string | null;
  isPinned: number;
  refTable: string | null;
}

interface Props {
  item: Item;
  onDelete: (itemId: number) => void;
  onTogglePin: (itemId: number, currentPinned: number) => void;
}

const ItemCard: React.FC<Props> = ({ item, onDelete, onTogglePin }) => {
  return (
    <div className={`timeline-item ${item.isPinned ? "pinned" : ""}`}>
      <div className={`timeline-item-type ${item.itemType}`}>
        {TYPE_ICONS[item.itemType] || "?"}
      </div>
      <div className="timeline-item-body">
        <h6>{item.title || item.itemType.charAt(0).toUpperCase() + item.itemType.slice(1)}</h6>
        {item.description && <p className="item-desc">{item.description}</p>}
        <div className="item-date">
          {item.eventDate || ""}
          {item.refTable && (
            <span style={{ marginLeft: 8, fontStyle: "italic", color: "#aaa" }}>
              (auto: {item.refTable})
            </span>
          )}
        </div>
      </div>
      <div className="timeline-item-actions">
        <Button
          variant="secondary"
          size="sm"
          onClick={() => onTogglePin(item.id, item.isPinned)}
          title={item.isPinned ? "Unpin" : "Pin"}
        >
          {item.isPinned ? "\u{1F4CC}" : "\u{1F4CD}"}
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={() => onDelete(item.id)}
          title="Delete"
        >
          &times;
        </Button>
      </div>
    </div>
  );
};

export default ItemCard;
